export const state = {
    cancel: null,
        token: null,
        tokenConstructor: null
}

export const mutations ={
    setCancel(state, data) {
        state.cancel = data;
    },
    setToken(state, data) {
        state.token = data;
    },
    setTokenConstructor(state, data) {
        state.tokenConstructor = data;
    }
}

export const actions = {
    setTokenConstructor({ commit, dispatch }, payload) {
        commit("setTokenConstructor", payload);
        dispatch("setToken");
    },
    setCancel({ commit }, payload) {
        commit("setCancel", payload);
    },
    cancel({ commit, state }) {
        state.cancel()
        commit(
            "setToken",
            new state.tokenConstructor(function executor(c) {
                commit("setCancel", c);
            })
        );
    },
    setToken({ commit, state }) {
        commit(
            "setToken",
            new state.tokenConstructor(function executor(c) {
                commit("setCancel", c);
            })
        );
    }
}

export const getters = {
    token: state => {
        return state.token;
    }
}
